export default __webpack_public_path__ + "static/monster@2x-27da4c6a43c1a71febd0379e2f8f61a1.png";